import React from 'react';

import {useTour} from '@reactour/tour';

import {Icon, Sizes} from '@pb/kit-component-icon';

import type {IconSize} from '@pb/kit-component-icon/dist/constants';

type Props = {
    className: string,
    icon: string,
    iconSize?: IconSize,
};

export const TourAnchor = (props: Props) => {
    const {
        className,
        icon,
        iconSize,
    } = props;

    const {isOpen} = useTour();

    return (
        <>
            {isOpen ? (
                <Icon
                    className={className}
                    type={icon}
                    size={iconSize || Sizes.Size_14}
                />
            ) : null}
        </>
    );
};
